export default __webpack_public_path__ + "media/icons/easystore-2fcb9148.png";